module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/026-qatar-d0c46839482a18cf3a60520ea9868192.svg";